import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../store/UserContext';

export default function ProtectedRoute({ children }) {
  const { user, ready } = useUser();
  if (!ready) {
    return <div className="p-6 text-sm sp-muted">Loading…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
